import { SUPPORT_EMAIL } from "@/config/support";

/**
 * Whoever loses the second factor is stuck on their own: only a superadmin can reset it
 * (`POST /api/users/{userId}/2fa/reset`), so the way out is a message to support. The draft names
 * the account, which is what support has to look up.
 */
export const supportResetHref = (account?: string) => {
  const subject = encodeURIComponent("Reset two-step verification");
  const body = encodeURIComponent(
    account
      ? `Please reset two-step verification on my account: ${account}`
      : "Please reset two-step verification on my account.",
  );
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};
